import React from "react";

// examples
const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const Login = React.lazy(() =>
  import("./components/modules/auth/components/Login")
);
const NewForm = React.lazy(() => import("./views/application/NewForm"));
const EthicsDeal = React.lazy(() => import("./views/Templates/EthicsDeal"));
const ApplicationList = React.lazy(() => import("./views/application/list"));
const ApplicationListDetail = React.lazy(() =>
  import("./views/application/ListDetail")
);
const SelfReport = React.lazy(() => import("./views/SelfReport/SelfReport"));
const SelfReportDetail = React.lazy(() =>
  import("./views/SelfReport/SelfReportDetail")
);
const MonthResponse = React.lazy(() =>
  import("./views/Response/MonthResponse")
);
const MonthResponseDetail = React.lazy(() =>
  import("./views/Response/MonthResponseDetail")
);
const Evaluation = React.lazy(() => import("./views/Evaluation/Evaluation"));
const EvaluationDetail = React.lazy(() =>
  import("./views/Evaluation/EvaluationDetail")
);
const SelfReportPreview = React.lazy(() =>
  import("./views/ReportPreview/SelfReportPreview")
);
const SelfReportPreviewDetail = React.lazy(() =>
  import("./views/ReportPreview/SelfReportPreviewDetail")
);
const ApplicationLoopScreen = React.lazy(() =>
  import("./views/application/ApplicationLoopScreen")
);
const ApplicationLoopScreenDetail = React.lazy(() =>
  import("./views/application/ApplicationLoopScreenDetail")
);
const DraftReport = React.lazy(() => import("./views/DraftReport/DraftReport"));
const EvaluatorReport = React.lazy(() =>
  import("./views/EvaluatorReport/EvaluatorReport")
);
const DraftReportDetail = React.lazy(() =>
  import("./views/DraftReport/DraftReportDetail")
);
const Consistency = React.lazy(() =>
  import("./views/ConsistentView/Consistency")
);
const ConsistencyDetail = React.lazy(() =>
  import("./views/ConsistentView/ConsistencyDetail")
);
const Editor = React.lazy(() => import("./views/Editor/Editor"));
const EditorDetail = React.lazy(() => import("./views/Editor/EditorDetail"));
const SpellingControl = React.lazy(() =>
  import("./views/SpellingControl/SpellingControl")
);
const SpellingControlDetail = React.lazy(() =>
  import("./views/SpellingControl/SpellingControlDetail")
);
const AppealTemplate = React.lazy(() =>
  import("./views/Templates/AppealTemplate")
);
const SekilselInceleme = React.lazy(() =>
  import("./views/SekilselInceleme/SekilselInceleme")
);
const SekilselIncelemeDetay = React.lazy(() =>
  import("./views/SekilselInceleme/SekilselIncelemeDetay")
);
const EthicsTemplate = React.lazy(() =>
  import("./views/Templates/EthicsTemplate")
);
const Try = React.lazy(() => import("./views/application/try"));

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/try", name: "Try", component: Try },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/login", name: "Login", component: Login },
  {
    path: "/appeal-template",
    name: "ÖDR Değerlendirme Şablonu",
    component: AppealTemplate,
  },
  {
    path: "/application-list",
    exact: true,
    name: "Başvurular",
    component: ApplicationList,
  },
  { path: "/new-app-form", name: "Yeni Başvuru Formu", component: NewForm },
  {
    path: "/application-list-detail",
    exact: true,
    name: "Başvuru Form Detayı",
    component: ApplicationListDetail,
  },
  {
    path: "/self-report",
    exact: true,
    name: "Öz değerlendirme Raporu",
    component: SelfReport,
  },
  {
    path: "/formal-review",
    exact: true,
    name: "Şekilsel İnceleme",
    component: SekilselInceleme,
  },
  {
    path: "/formal-review-detail",
    name: "Şekilsel İnceleme Detayı",
    component: SekilselIncelemeDetay,
  },
  {
    path: "/self-report-detail",
    name: "Öz değerlendirme Raporu Detayı",
    component: SelfReportDetail,
  },
  {
    path: "/month-response",
    exact: true,
    name: "30 Gün Yanıtı",
    component: MonthResponse,
  },
  {
    path: "/month-response-detail",
    name: "30 Gün Yanıtı Detayı",
    component: MonthResponseDetail,
  },
  {
    path: "/application-loop",
    name: "SAK'tan Geri Dönen Programlar",
    component: ApplicationLoopScreen,
  },
  {
    path: "/application-loop-detail",
    name: "SAK'tan Geri Dönen Programlar Detayı",
    component: ApplicationLoopScreenDetail,
  },
  {
    path: "/ethics-deal",
    name: "Etik Sözleşme Şablonu",
    component: EthicsDeal,
  },
  {
    path: "/ethics-template",
    name: "Etik Sözleşme Şablonu",
    component: EthicsTemplate,
  },
  {
    path: "/self-report-preview",
    exact: true,
    name: "ÖDR Ön İnceleme",
    component: SelfReportPreview,
  },
  {
    path: "/self-report-preview-detail",
    name: "ÖDR Ön İnceleme Detayı",
    component: SelfReportPreviewDetail,
  },
  {
    path: "/draft-report",
    exact: true,
    name: "Taslak Rapor",
    component: DraftReport,
  },
  {
    path: "/evaluator-report",
    exact: true,
    name: "Değerlendirici Raporları",
    component: EvaluatorReport,
  },
  {
    path: "/draft-report-detail",
    name: "Taslak Rapor Detayı",
    component: DraftReportDetail,
  },
  {
    path: "/evaluation",
    exact: true,
    name: "Değerlendirme",
    component: Evaluation,
  },
  {
    path: "/evaluation-detail",
    name: "Değerlendirme Detayı",
    component: EvaluationDetail,
  },
  {
    path: "/consistency",
    exact: true,
    name: "Program Raporları",
    component: Consistency,
  },
  {
    path: "/consistency-detail",
    name: "Tutarlılık Detayı",
    component: ConsistencyDetail,
  },
  { path: "/editor", exact: true, name: "Editör", component: Editor },
  { path: "/editor-detail", name: "Editör Detayı", component: EditorDetail },
  {
    path: "/spelling-control",
    exact: true,
    name: "Yazım Kontrol",
    component: SpellingControl,
  },
  {
    path: "/spelling-control-detail",
    name: "Yazım Kontrol Detayı",
    component: SpellingControlDetail,
  },
  { path: "/application", name: "Başvuru", component: ApplicationList },
];

export default routes;
